module.exports = __webpack_public_path__ + "static/media/paintings.fee48627.JPG";